import Css from './Css.js';
import LefeDragBtn from './LeftDragBtn/LeftDragBtn.js';
import RightDragBtn from './RightDragBtn/RightDragBtn.js';
import Progress from './Progress/Progress.js';
import throttle from 'lodash.throttle';

// 灰白色时间滑轴组件
function TimeSlider(props){
  const {middleWidth,videoEl,selStartTime,selEndTime,timeScaleInfo,lvsPatternEditorId,timeLinePosition,videoTotalTime} = props.data;
  const {pauseVideo,hideCopyPaste,setTimeLinePosition,setSelStartTime,setSelEndTime,setTimeScaleInfo} = props.method;
  const leftData = { left: timeLinePosition.left };
  const rightData = { right: (middleWidth - timeLinePosition.width - timeLinePosition.left) };
  const editorEl = document.getElementById(lvsPatternEditorId);

  //时间选择区滑动计算
  const onMouseDownSelTimeLine = (e)=> {
    pauseVideo();
    let prevX = e.clientX;
    editorEl.onmousemove = throttle(function(ev) {
      hideCopyPaste();
      let moveDistanceX = ev.clientX - prevX; //移动距离
      let sliderW = timeLinePosition.width;
      //左移的偏移时间量
      let lmTime = parseInt((moveDistanceX/middleWidth)*videoTotalTime);
      let sTime = parseInt(selStartTime + lmTime);
      let eTime = selEndTime + lmTime;
      if(sTime < 0){
        sTime = 0;
        eTime = parseInt((sliderW/middleWidth)*videoTotalTime);
      }
      if(eTime > videoTotalTime){
        sTime = videoTotalTime - parseInt((sliderW/middleWidth)*videoTotalTime);
        eTime = videoTotalTime;
      }
      if(sTime >=0 && eTime <= videoTotalTime){
        let hzLeft = timeLinePosition.left + moveDistanceX;
        if(hzLeft<0){
          hzLeft = 0;
        }else if((hzLeft + sliderW) > middleWidth){
          hzLeft = middleWidth - sliderW;
        }
        let selTime = selEndTime - selStartTime;
        setTimeLinePosition({ width:sliderW,left:hzLeft });
        setSelStartTime(sTime);
        setSelEndTime(eTime);
        setTimeScaleInfo({
          ...timeScaleInfo,
          selStartTime: sTime,
          selEndTime: eTime,
          selTime: selTime,
          width: sliderW, 
          slideBtn: "right"
        });
      }
      editorEl.onmouseup = function(){
        editorEl.onmousedown = null;
        editorEl.onmousemove = null;
      };
      return false;
    }, 50);
  }

  //滑动计算选区
  const onMouseDownDragBtn = (e, dir)=> {
    pauseVideo();
    let prevX = e.clientX;
    editorEl.onmousemove = throttle(function(ev) {
      hideCopyPaste();      
      //计算时间滑轴选区
      let selTime = 0;  //滑轴选区时长
      let sliderW = 0;  //滑轴选区宽度
      let hzLeft = 0;   //滑轴左侧按钮的left值(即起始位置)
      let hzRight = 0;   //滑轴右侧按钮的right值(即结束位置)
      if(dir === 'left'){
        let moveDistanceX = ev.clientX - prevX; //移动距离（即timeline缩短的长度）
        sliderW = timeLinePosition.width - moveDistanceX;
        if(sliderW > 1){
          if(sliderW >= middleWidth){
            sliderW = middleWidth;
          }
          hzLeft = timeLinePosition.left + moveDistanceX;
          if(hzLeft >= 0){
            //计算滑轴选择的区域时长
            selTime = (sliderW/middleWidth)*videoTotalTime;
              if(sliderW >= 10 && selTime >= 500){
              let selStartTimeTmp = parseInt((hzLeft/middleWidth)*videoTotalTime);
              if(selStartTimeTmp <=0){
                selStartTimeTmp = 0;
              }
              setSelStartTime(selStartTimeTmp);
              setTimeLinePosition({ width:sliderW, left: hzLeft>0?hzLeft:0 });
              setTimeScaleInfo({
                ...timeScaleInfo,
                selStartTime: selStartTimeTmp,
                selTime: selTime,
                width: sliderW, 
                slideBtn: "right"
              });
            }
          }
        }
      }else{
        let moveDistanceX = prevX - ev.clientX; //移动距离（即timeline缩短的长度）
        sliderW = timeLinePosition.width - moveDistanceX;
        if(sliderW > 1){
          if(sliderW >= middleWidth){
            sliderW = middleWidth;
          }
          //计算滑轴选择的区域时长
          selTime = (sliderW/middleWidth)*videoTotalTime;
          if(sliderW>=10 && (sliderW + timeLinePosition.left) <= middleWidth  && selTime >= 500){
            hzRight = timeLinePosition.left;
            let selEndTimeTmp = ((sliderW + hzRight)/middleWidth)*videoTotalTime;
            if(selEndTimeTmp >= videoTotalTime){
              selEndTimeTmp = videoTotalTime;
            }
            setSelEndTime(selEndTimeTmp);
            setTimeLinePosition({ width:sliderW, left: hzRight>0?hzRight:0 });
            setTimeScaleInfo({
              ...timeScaleInfo,
              selEndTime: selEndTimeTmp,
              selTime: selTime,
              width: sliderW, 
              slideBtn: "right"
            });
          }
        }
      }

      editorEl.onmouseup = function(){
        editorEl.onmousedown = null;
        editorEl.onmousemove = null;
      };
      return false;
    }, 50);
  }

  return (
    <>
      <div style={Css.sliderBox(middleWidth)}>
        <Progress data={{middleWidth,videoEl,videoTotalTime,selStartTime,selEndTime }}></Progress>
        <div style={Css.timeSlider(timeLinePosition.width, timeLinePosition.left)} onMouseDown={ (e)=>{ onMouseDownSelTimeLine(e) } }></div>
        <LefeDragBtn leftData={leftData} onMouseDownDragBtn={ (e, left)=>{ onMouseDownDragBtn(e, left) } } ></LefeDragBtn>
        <RightDragBtn rightData={rightData} onMouseDownDragBtn={ (e, right)=>{ onMouseDownDragBtn(e, right) } } ></RightDragBtn>
      </div>
    </>
  )
}

export default TimeSlider;